import React, { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../../../manager'
import CreationToolSuperCutField from '../../../../../types/super-cut-field'
import CreationToolUserRestriction from '../../../../../types/user-restriction'
import { GridBlock } from '../../../../blocks'
// import FontField from './fields/font'
import TitleField from './fields/title'
// import WatermarkField from './fields/watermark'

const Fields = styled(GridBlock)`
    gap: 30px;
    margin: 30px 0;
`

const CreationCaptureInfoDetails = () => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)

    // filter out any fields that the user doesn't have access to.
    const fields = CreationToolSuperCutField.all('capture').filter(field => {
        const userRestriction = CreationToolSuperCutField.userRestriction(field)
        return CreationToolUserRestriction.hasAccess(userRestriction, userRestrictionAccess)
    })

    const fieldComponents = fields.map(field => {
        switch (field) {
            case CreationToolSuperCutField.CaptureTitle:
                return TitleField
            // TODO: Uncomment when ready for production.
            // case CreationToolSuperCutField.Watermark:
            //     return WatermarkField
            // case CreationToolSuperCutField.Font:
            //     return FontField
            default:
                return null
        }
    })

    return (
        <Fields columns={2}>
            {fieldComponents.map((Field, i) => (Field ? <Field key={fields[i]} field={fields[i]} /> : null))}
        </Fields>
    )
}

export default CreationCaptureInfoDetails
